import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/WhyChooseUs.css';
import { FaChartLine, FaShieldAlt, FaArrowRight, FaTools } from 'react-icons/fa';
import { FaMoneyBillTransfer } from 'react-icons/fa6';

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: <FaShieldAlt />,
      title: 'Trusted Fiscal Sponsorship',
      description:
        'Cause and Impact provides the structure, oversight, and administrative support needed to help charitable projects operate responsibly and effectively. We handle the operational and compliance framework so project leaders can stay focused on advancing their work.',
    },
    {
      icon: <FaChartLine />,
      title: 'Clear Financial Visibility',
      description:
        'Every project fund is tracked within our internal financial structure to support accurate reporting, organized stewardship, and clear visibility into project activity. That means a stronger operational foundation for managing donations, expenses, and charitable programming with confidence.',
    },
    {
      icon: <FaTools />,
      title: 'Continuously Evolving Infrastructure',
      description:
        'Our systems are designed to continuously expand in capability, visibility, and efficiency. We focus on delivering practical, high-value tools while consistently enhancing the experience to better support projects as they grow.',
    },
    {
      icon: <FaMoneyBillTransfer />,
      title: 'Low Fees, High Capability',
      description:
        'We offer a low-fee fiscal sponsorship model backed by in-house operational, systems, and development expertise. Our team brings real experience building and supporting infrastructure in this space, allowing us to deliver strong support today while continuing to strengthen what we offer over time.',
    },
  ];

  return (
    <section className="why-choose-us">
      <div className="container">
        <h2>Why Choose Cause and Impact?</h2>
        <p>
          Cause and Impact combines experienced fiscal sponsorship support with strong internal
          operations, thoughtful financial stewardship, and modern systems built to help charitable
          projects move forward with confidence.
        </p>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div className="benefit" key={index}>
              <div className="icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>

        <Link to="/services" className="learn-more-link">
          <span>Explore Our Services</span>
          <FaArrowRight className="arrow-icon" />
        </Link>
      </div>
    </section>
  );
};

export default WhyChooseUs;